import { render, staticRenderFns } from "./BaseDragIcon.vue?vue&type=template&id=f76fc580"
import script from "./BaseDragIcon.vue?vue&type=script&lang=js"
export * from "./BaseDragIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports